
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar2 from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {Login} from "../../Login"
import { getAuth, onAuthStateChanged } from "firebase/auth";

import AdComponent from './AdComponent';
import {FirebaseDB2} from "../../FirebaseDB2"
import {VisitCounter} from "../../Counter"
// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";



class LoginCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login

    }

    this.previousWidth = -1;

    
  }

  render() {
    return (

      

      <Container fluid className={classNames('LoginCom', { 'is-open': this.props.isOpen })}>
                {/* <NavBar2 toggle={this.props.toggle} /> */}
        
        <Login></Login>
        {/* <FirebaseDB2></FirebaseDB2>  */}
        

        <VisitCounter name = "login"></VisitCounter>

      </Container>
      
      
    );
  }
}




export default LoginCom;
